import type { CSSProperties } from "react";

import type { EvidencePillModel } from "./provenance.model.ts";

/**
 * The uppercase grade beside an entry.
 *
 * The qualifier is rendered as visually hidden text rather than a tooltip: the
 * pill says "VERIFIED FACT" and a screen reader hears "Submitter's own evidence
 * grade: VERIFIED FACT", which is the sentence the sighted reader is given by
 * the help text under the select. Both audiences get told whose statement it is.
 */
export function EvidencePill({ pill }: { pill: EvidencePillModel }) {
  return (
    <span
      className="provenance__pill"
      style={{ "--grade": pill.token, "--grade-bg": pill.bgToken } as CSSProperties}
    >
      <span className="provenance__sr">{pill.qualifier} </span>
      {pill.label}
    </span>
  );
}
